import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

/**
 * Conditions Generales d'Utilisation - Ember (beta gratuite).
 * Document juridique simplifie : ton clair, beta = pas de SLA.
 */
export function CguPage() {
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto py-8 px-4 space-y-6">
      <Button variant="ghost" size="sm" onClick={() => navigate(-1)}>
        Retour
      </Button>

      <header className="space-y-2">
        <h1 className="text-3xl font-bold text-primary">Conditions Générales d'Utilisation</h1>
        <p className="text-sm text-muted-foreground">
          Dernière mise à jour : 16 mai 2026 - Version beta
        </p>
      </header>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">1. Présentation du service</h2>
        <p>
          Ember est un jeu de questions et réponses pour relations de tous types (couples,
          partenaires occasionnels, amis proches, polyamoureux, crushes). Le service est édité par
          Nicolas DODEMANT sous la marque <strong>Black Potion</strong> et accessible à l'adresse
          https://emberapp.duckdns.org.
        </p>
        <p>
          Ember est actuellement en <strong>beta gratuite</strong>. Le service peut évoluer, être
          interrompu temporairement ou arrêté définitivement sans préavis.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">2. Acceptation des CGU</h2>
        <p>
          En utilisant Ember, tu acceptes les présentes CGU dans leur intégralité. Si tu n'es pas
          d'accord avec une ou plusieurs clauses, tu ne dois pas utiliser le service.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">3. Public concerné : 18 ans et plus</h2>
        <p>
          Ember s'adresse exclusivement aux personnes <strong>majeures</strong> (18 ans révolus).
          Certains contenus sont à caractère sexuel explicite et destinés à un public adulte
          consentant. Une vérification d'âge est demandée au premier accès. En passant cette
          vérification, tu certifies sur l'honneur avoir 18 ans ou plus.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">4. Accès au service</h2>
        <p>
          L'accès à Ember est gratuit pendant toute la durée de la beta. Aucun paiement n'est requis
          et aucune information bancaire n'est demandée.
        </p>
        <p>
          Ember est fourni <em>en l'état</em>, sans garantie de disponibilité, de performance ou de
          fonctionnement continu. Il n'y a aucun engagement de service (SLA). Des interruptions
          techniques, des bugs ou des pertes de données peuvent survenir.
        </p>
        <p>Tu peux arrêter d'utiliser Ember à tout moment, sans formalité.</p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">5. Comportement attendu</h2>
        <p>En utilisant Ember, tu t'engages à :</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>respecter les autres joueuses et joueurs ;</li>
          <li>
            ne jamais forcer ou faire pression sur une autre personne pour répondre à une question
            ou tenter un défi ;
          </li>
          <li>respecter le choix de chacun(e) de skipper, refuser ou quitter à tout moment ;</li>
          <li>ne pas utiliser Ember pour harceler, menacer ou nuire à autrui ;</li>
          <li>
            ne pas tenter d'accéder aux données d'autres utilisateurs ni de perturber le service.
          </li>
        </ul>
        <p>
          Le consentement de chaque participant(e) est central. Si une personne souhaite arrêter,
          son choix doit être respecté immédiatement.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">6. Contenu généré par les utilisateurs</h2>
        <p>
          Ember te permet d'écrire des réponses libres aux questions posées. Tu es seul(e)
          responsable du contenu que tu publies via ces réponses. Tu garantis que ton contenu ne
          viole pas les lois en vigueur, les droits de tiers, ou les présentes CGU.
        </p>
        <p>
          Black Potion se réserve le droit de supprimer toute session ou contenu manifestement
          illicite ou contraire aux CGU, sans préavis.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">7. Propriété intellectuelle</h2>
        <p>
          Les questions, l'interface, les visuels, le code source et l'ensemble des éléments
          composant Ember sont la propriété exclusive de Nicolas DODEMANT / Black Potion. Toute
          reproduction, diffusion ou exploitation non autorisée est interdite.
        </p>
        <p>
          Tu conserves la propriété des réponses libres que tu écris. En les saisissant dans Ember,
          tu nous accordes uniquement le droit technique de les stocker et de les transmettre aux
          autres joueurs de ta session, dans le seul but de faire fonctionner le jeu.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">8. Limitation de responsabilité</h2>
        <p>
          Ember est un jeu. Black Potion ne saurait être tenu responsable des conséquences
          personnelles, émotionnelles, relationnelles ou autres résultant de l'utilisation du
          service.
        </p>
        <p>
          Dans la limite autorisée par la loi, Black Potion ne pourra être tenu responsable des
          dommages indirects, pertes de données, atteintes à la réputation ou interruptions de
          service.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">9. Données personnelles</h2>
        <p>
          Les modalités de traitement des données personnelles sont détaillées dans notre{' '}
          <a href="/legal/confidentialite" className="text-primary underline">
            Politique de confidentialité
          </a>
          .
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">10. Modification des CGU</h2>
        <p>
          Les présentes CGU peuvent évoluer, notamment au cours de la beta. Toute modification sera
          signalée sur cette page avec une nouvelle date de mise à jour. L'utilisation continue
          d'Ember après modification vaut acceptation des nouvelles CGU.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">11. Loi applicable et juridiction</h2>
        <p>
          Les présentes CGU sont soumises au droit français. En cas de litige, et après tentative de
          résolution amiable, les tribunaux français seront seuls compétents, sous réserve des
          règles impératives de protection des consommateurs.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">12. Contact</h2>
        <p>
          Pour toute question relative aux présentes CGU, tu peux nous écrire à{' '}
          <a href="mailto:kavaliero37@gmail.com" className="text-primary underline">
            {'kavaliero37@gmail.com'}
          </a>
          .
        </p>
      </section>
    </div>
  );
}
